import Component from "@bythepixel/component-loader";

const DEFAULTS = {
  tabLink: "data-tab-link",
};

export default class SectionTabs extends Component {
  static selector = "[data-comp-section-tabs]";
  static loaderPriority = "in-view";

  constructor(containerEl, options = DEFAULTS) {
    super(containerEl);
    Object.assign(this.$options, DEFAULTS, options);
    this.tabLinks = this.$container.querySelectorAll(
      `[${this.$options.tabLink}]`
    );
    this.tabContents = this.$container.querySelectorAll("[data-tab-content]");
    this.setParams = this.$container.hasAttribute("data-set-params");
    this.noInitialTab = this.$container.hasAttribute("data-no-initial-tab");
    this.addListeners();

    if (!this.noInitialTab) {
      this.activateInitialTab();
    }
  }

  addListeners() {
    for (let i = 0; i < this.tabLinks.length; i++) {
      const tabContentId = this.tabLinks[i].dataset.tabLink;
      this.tabLinks[i].addEventListener("click", () => {
        this.activateTab(tabContentId, this.setParams);
      });
    }
  }

  activateTab(tabContentId, setQueryParam) {
    // Hide all tab content
    this.tabContents.forEach((tabContent) => {
      tabContent.style.display = "none";
    });

    // Show active tab content
    document.querySelector(
      `[data-tab-content="${tabContentId}"]`
    ).style.display = "block";

    // Remove active class from tab links
    for (let i = 0; i < this.tabLinks.length; i++) {
      this.tabLinks[i].classList.remove("active");
    }

    // Add active class to active tab link
    this.$container
      .querySelector(`[${this.$options.tabLink}="${tabContentId}"]`)
      .classList.add("active");

    if (setQueryParam) {
      this.setSearchParam(tabContentId);
    }
  }

  setSearchParam(tabContentId) {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    if (params.tab !== tabContentId) {
      urlSearchParams.set("tab", tabContentId);
      window.history.pushState(null, null, `?${urlSearchParams.toString()}`);
    }
  }

  activateInitialTab() {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    if (params.tab) {
      this.activateTab(params.tab, false);
    } else {
      this.activateTab(
        this.tabLinks[0].getAttribute(this.$options.tabLink),
        false
      );
    }
  }
}
